import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import QRCode from 'react-qr-code';
import { useTitle } from '../../shared/hooks/useTitle';
import api from '../../shared/services/api/api';
import Loading from '../components/Loading';
import PageContainer from '../components/PageContainer';
import PageHeader from '../components/PageHeader';

const Setup = () => {
  const { pazienteId = '' } = useParams();
  const { secretGdSuiteCode = '' } = useParams();
  const [fullUrl, setFullUrl] = useState<string | null>('');
  // const [nome, setNome] = useState<string | null>('');
  // const [cognome, setCognome] = useState<string | null>('');

  const [loading, setLoading] = useState<boolean>(false);
  const [title, setTitle] = useState<string>('');
  const [subtitle, setSubTitle] = useState<string>('');

  useTitle(title);

  useEffect(() => {
    setLoading(true);
    const setupB2c = async () => {
      const response = await api.setup({ pazienteId, secretGdSuiteCode }).catch((error) => {
        console.error(error);
        setLoading(false);
      });
      if (response.status === 200 && response?.full_url) {
        setFullUrl(response.full_url);
      }
      if (response.status === 200 && response?.paziente) {
        // setNome(response.paziente?.nome);
        // setCognome(response.paziente?.cognome);
        setTitle('');
        setSubTitle('Gentile ' + response.paziente?.nome + ' ' + response.paziente?.cognome + ',');
      }

      setLoading(false);
    };
    if (pazienteId !== '') {
      setupB2c();
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <Loading />;
  }

  if (pazienteId === null || pazienteId === '' || fullUrl === '' || fullUrl === null) {
    return <div>Si è verificato un errore.</div>;
  }

  return (
    <PageContainer>
      <>
        <PageHeader title={title} subtitle={subtitle} />
        <p>Grazie per aver acquistato il nostro test genetico.</p>
        <p>
          Questo è il primo passo per intraprendere un percorso su misura per il tuo benessere e la tua salute. Leggi
          bene le istruzioni che troverai allegate e preparati a effettuare il prelievo di saliva aspettando almeno
          un&apos;`ora dopo i pasti.
        </p>

        <p>
          Poi ti chiederemo di ritagliarti 10 minuti per rispondere ad alcune domande su di te e prenotare il ritiro del
          campione: quando avrai effettuato il prelievo e sarai pronto a spedire il tuo kit ai nostri laboratori
          scannerizza il qr code che trovi qui sotto.
        </p>
        <p>
          Se hai bisogno di assistenza il nostro staff è sempre a tua disposizione, ci puoi contattare via mail
          all&apos;`indirizzo <a href={'mailto:assistenza@ngbgenetics.com'}>assistenza@ngbgenetics.com</a> o al numero
          di telefono 051 6153024
        </p>
        <div className="text-center mt-20">
          <QRCode
            size={128}
            style={{ height: 'auto', maxWidth: '256', width: '128' }}
            value={fullUrl}
            viewBox={`0 0 256 256`}
          />
          <p>
            <a href={fullUrl} target="new">
              Clicca qui per aprire il link
            </a>
          </p>
        </div>
      </>
    </PageContainer>
  );
};

export default Setup;
